import type { MenuItemHeader, MenuItemLink } from "../../../../common/types.ts";
import i18n from "./i18n.ts";

const t = (text: string) => {
	const translated = i18n.t(`menu.${text}`, { ns: "ui", defaultValue: text });
	if (translated !== text) {
		return translated;
	}

	const underscored = text.replace(/ /g, "_");
	if (underscored !== text) {
		return i18n.t(`menu.${underscored}`, {
			ns: "ui",
			defaultValue: text,
		});
	}

	return translated;
};

const translateText = (text: MenuItemLink["text"]): MenuItemLink["text"] => {
	if (typeof text === "string") {
		return t(text);
	}
	if (text && typeof text === "object" && "side" in (text as object)) {
		const obj = text as { side: string; top: unknown };
		return { ...obj, side: t(obj.side) } as MenuItemLink["text"];
	}
	return text;
};

export const translateMenuLinks = (
	items: (MenuItemLink | MenuItemHeader)[],
): (MenuItemLink | MenuItemHeader)[] => {
	return items.map((item) => {
		if (item.type === "header") {
			return {
				...item,
				long: t(item.long),
				short: t(item.short),
				children: translateMenuLinks(
					item.children as (MenuItemLink | MenuItemHeader)[],
				) as any,
			};
		}
		return { ...item, text: translateText(item.text) };
	}) as (MenuItemLink | MenuItemHeader)[];
};
